export default __webpack_public_path__ + "static/media/GF_MYST_Horizontal.8c73cbd3.jpg";